(function (window) {
  /**
   * BatchGeoMarkerMeasureMarkerOverlay exists because of z-indexing works in
   * Google Maps. We want our marker measure to always be on top of everything
   * so we can't lose it behind other things. For example, if you tried to use
   * a marker (the way it was before this) and you dragged the marker over a
   * cluster it would go behind it. If you left go there you would never be
   * able to recover it until you refreshed. This is because Google Maps has
   * what they call "panes" which are essentially z-indexing layers. It starts
   * at 0 (the map) and goes to 4 (floatPane). Markers are at level 2,
   * clusters are at level 3 which means we need to go to level 4. This is
   * only possible making a customer overlay.
   *
   * This overlay just mimics what a custom google.maps.Marker would look at
   * act like with a draggable:true property.
   *
   * @param {google.maps.LatLng} position The LatLng instance to set the
   * overlay's starting position at.
   */
  function BatchGeoMarkerMeasureMarkerOverlay(position) {
    // The icon size in pixels
    this._iconSize = { x: 32, y: 48 };
    // This is used to clean up events attached outside the scope of the
    // $overlayElement (such as on the window and map element);
    this._eventNamespace = "BatchGeoMarkerMeasureMarkerOverlay";
    this.position = position;
    this.$overlayElement = this.createOverlayElements();
    this.setMap(window.batchGeoGoogleMapsManager.getMap());
  }

  // We need to mixin Google Map's OverlayView prototype with ours for the
  // overlay to work. It expects a onAdd, draw, and onRemove method.
  BatchGeoMarkerMeasureMarkerOverlay.prototype = new google.maps.OverlayView();

  /**
   * This will generate an overlay DOM element returns in a jQuery object. In
   * it is the wrapper (.marker-measure-marker-overlay) as well as the icon
   * which is an SVG image.
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.createOverlayElements =
    function () {
      var $overlayIcon = $("<img />", {
        src: BatchGeoSvgMarkerIcon({
          type: "measureDistancePin",
          template: { width: this._iconSize.x, height: this._iconSize.y },
        }).url,
      });

      return $("<div />", {
        html: [$overlayIcon],
        addClass: "marker-measure-marker-overlay",
      });
    };

  /**
   * This method should be called when you want to indicate the marker overlay
   * is starting to be dragged. It will dispatch the drag start event for
   * listeners to do stuff against and it will also lock the map itself from
   * being dragged around until onDragEnd is called.
   *
   * @param {Event} event a jQuery/DOM event Object.
   * @see {@link BatchGeoMarkerMeasureMarkerOverlay.onDragEnd}
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.onDragStart = function (event) {
    // This is dispatching the start point (or "dragOriginPoint") to get the
    // difference of when onDrag is called.
    BatchGeoStore.dispatch({
      type: "MARKER_MEASURE_DRAG_START",
      x: event.clientX,
      y: event.clientY,
    });

    // Sets the map to draggable:false. Draggable is what allows panning.
    // If this is left true the map will drag with the marker.
    this.map.set("draggable", false);
  };

  /**
   * This method should be called when you want to update the position of the
   * element being dragged. As it's named, onDrag, it assumes the element is
   * being dragged. This means you should check if it's in a "draggable" state
   * or not. If you were to call this before calling onDragStart it will run.
   * This is on purpose as it tries not to make any assumptions of when you
   * want onDrag to be run.
   *
   * The logic in this method is primarily around converting pixels to LatLng
   * and vice versa. We need an apples to apples pixel point to LatLng point
   * to be able to drag the overlay. The mouse is using the pixels on the
   * screen while the overlay is in LatLng.
   *
   * @param {Event} event a jQuery/DOM event Object.
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.onDrag = function (event) {
    var state = BatchGeoStore.getState().MarkerMeasure;
    var left = state.dragOriginPoint.x - event.clientX;
    var top = state.dragOriginPoint.y - event.clientY;

    // Here we are taking the position the marker is at and finding out the
    // pixel location on the screen for it.
    var pos = this.getProjection().fromLatLngToDivPixel(this.position);

    // Now we update this.position by using the pixel value, getting the
    // difference of the starting point and where it is now (i.e. if it
    // started at 10px left and you moved it 5px more left it'd be 15px)
    // and then taking that pixel value and turning it into a LatLng so that
    // Google Maps can place it.
    this.position = this.getProjection().fromDivPixelToLatLng(
      new google.maps.Point(pos.x - left, pos.y - top),
    );

    // Once everything is updated with the new coordinates we can redraw
    this.draw();

    // We dispatch the new coordinates for components listenings to it so
    // they can update with the drag. For example, the polylines will need
    // the new coordinates to point the lines to the new location.
    BatchGeoStore.dispatch({
      type: "MARKER_MEASURE_DRAG",
      position: this.position,
      x: event.clientX,
      y: event.clientY,
    });
  };

  /**
   * This method should be called when you want to indicate the dragging has
   * ended. This will make the map draggable (aka pannable) again. It will
   * also update the state so that isDragging is false.
   *
   * @param {Event} event a jQuery/DOM event Object.
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.onDragEnd = function (event) {
    // Now that dragging has ended we need to allow map panning again
    this.map.set("draggable", true);

    // Send off the final location. You shouldn't ever really need the
    // coordinates sent off here as these should be the same as the last
    // MARKER_MEASURE_DRAG event but it sends it off in case the browser
    // misses a tick. Generally this is more to know dragging stopped and
    // you can do things like update the UI to indicate dragging had stopped
    BatchGeoStore.dispatch({
      type: "MARKER_MEASURE_DRAG_STOP",
      position: this.position,
      x: event.clientX,
      y: event.clientY,
    });
  };

  /**
   * onAdd is called when the map's panes are ready and the overlay has been
   * added to the map. This is called from the google.maps.OverlayView class.
   * We use this to attach all our events and add the overlay element into the
   * web page.
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.onAdd = function () {
    var self = this;

    this.getPanes().floatPane.appendChild(this.$overlayElement[0]);

    // We attach mousedown to the actual element but the mousemove event
    // will need to be on the entire map.
    this.$overlayElement.on(
      "mousedown." + this._eventNamespace,
      function (event) {
        self.onDragStart(event);
      },
    );

    // We want to track the mouse moving on the entire map since this is
    // where you can drag it. This is where we will get the diff in pixels
    // to find out where we need to place the icon.
    $(self.map.getDiv()).on(
      "mousemove." + this._eventNamespace,
      function (event) {
        // We only want to trigger the onDrag method if it's in dragging
        // mode and not just panning the map or something else.
        if (BatchGeoStore.getState().MarkerMeasure.isDragging) {
          self.onDrag(event);
        }
      },
    );

    // Since the user could move their mouse anywhere we want to trigger the
    // mouseup if you mouse up anywhere on the screen. I.e. if you mouse up
    // on the legend it should still trigger onDragEnd.
    $(window).on("mouseup." + this._eventNamespace, function (event) {
      self.onDragEnd(event);
    });
  };

  /**
   * Shows the marker overlay when hidden. Before showing it again it will
   * first update the positioning of the marker so that it displays as if you
   * were to have called new BatchGeoMarkerMeasureMarkerOverlay().
   *
   * @param {google.maps.LatLng} position The LatLng instance to set the
   * overlay's starting position at.
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.show = function (position) {
    this.position = position;
    this.draw();
    // Since hiding removes the handlers we call onAdd to attach the
    // handlers again
    this.onAdd();
    this.$overlayElement.show();
  };

  /**
   * Hides the marker overlay. It does NOT destroy it.
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.hide = function () {
    this.$overlayElement.hide();
    // Remove all handlers since some are attached to the window and map
    // and will keep triggering even though the overlay element is hidden
    $(window, this.map.getDiv()).off("." + this._eventNamespace);
  };

  /**
   * The google.maps.OverlayView API invokes a separate draw() method on the
   * overlay whenever it needs to draw the overlay on the map, including when
   * first added. We use this place the overlay element onto the page.
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.draw = function () {
    var pixelPosition = this.getProjection().fromLatLngToDivPixel(
      this.position,
    );

    this.$overlayElement.css({
      // We use the icon size and divide by two to get the center point
      left: pixelPosition.x - this._iconSize.x / 2,
      top: pixelPosition.y - this._iconSize.y / 2,
      width: this._iconSize.x,
      height: this._iconSize.y,
    });
  };

  /**
   * The onRemove() method will be called automatically from the API if we
   * ever set the overlay's map property to 'null'. This is called from the
   * google.maps.OverlayView class. We use this to remove the overlayElement
   * we injected into the DOM.
   *
   * ⚠️ WARNING ⚠️
   * For unknown reasons (despite many hours looking into it) once you destroy
   * this it will not be able to call .getProjection() properly. Instead of
   * returning the projection instance it will return null. It is recommended
   * you just use hide() method rather than ever destroying this..
   *
   * The bug report: https://github.com/pholmstr/batchgeo/issues/2395
   */
  BatchGeoMarkerMeasureMarkerOverlay.prototype.onRemove = function () {
    this.$overlayElement.remove();
    this.$overlayElement = null;
    // important: we don't use this.map because it will be null here. The
    // overlay has been removed now and "this" (the overlay) has no map
    // attached to it.
    $(window, window.batchGeoGoogleMapsManager.getMap().getDiv()).off(
      "." + this._eventNamespace,
    );
  };

  window.BatchGeoMarkerMeasureMarkerOverlay =
    BatchGeoMarkerMeasureMarkerOverlay;
})(window);
